import 'bootstrap-slider'

$('input[data-slider-measuring-range]').slider({
    formatter: function(value) {
        if (!Array.isArray(value))
            return;
        return value[0] + ' - ' + value[1];
    }
});

$('input[data-toggle-slider]').click(function() {
    if(this.checked)
        $('#' + this.getAttribute('data-toggle-slider')).slider('enable');
    else
        $('#' + this.getAttribute('data-toggle-slider')).slider('disable');
});
